import { render } from "./results-board-join.vue?vue&type=template&id=07ef6d41&scoped=true&ts=true"
import script from "./results-board-join.vue?vue&type=script&lang=ts"
export * from "./results-board-join.vue?vue&type=script&lang=ts"

import "./results-board-join.vue?vue&type=style&index=0&id=07ef6d41&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07ef6d41"]])

export default __exports__